import { render, staticRenderFns } from "./AdvanceRequisitesListReadonly.vue?vue&type=template&id=06ddfa1c&"
import script from "./AdvanceRequisitesListReadonly.vue?vue&type=script&lang=js&"
export * from "./AdvanceRequisitesListReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports